import { useState } from 'react';
import { Button, Input } from '@nazka/nazka.mapframe.components';
import { toast } from 'react-toastify';
import { useMutation } from '@tanstack/react-query';

import { isValidEmail } from '@services/utils.service';
import { adminCreateUser } from '@services/admin.service';

import './admin-create-user.styl';
import queryClient from '@App/app.query-client';

function AdminCreateUser({
  onClose,
  companyId,
}) {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [errors, setErrors] = useState({});

  const createUserMutation = useMutation({
    mutationFn: adminCreateUser,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['company', 'users'] });
      toast.success('Gebruiker is toegevoegd');
      onClose();
    },
    onError: () => {
      toast.error('Er ging helaas iets mis bij het toevoegen van de gebruiker');
    },
  });

  const onSubmit = () => {
    const newErrors = {};

    if (!firstName) {
      newErrors.firstName = 'Voornaam is verplicht';
    }

    if (!lastName) {
      newErrors.lastName = 'Achternaam is verplicht';
    }

    if (!email) {
      newErrors.email = 'Email is verplicht';
    }

    if (!isValidEmail(email)) {
      newErrors.email = 'Email is ongeldig';
    }

    if (Object.keys(newErrors).length) {
      setErrors(newErrors);
    } else {
      setErrors({});
      createUserMutation.mutate({
        firstName,
        lastName,
        email,
        companyId,
      });
    }
  };

  return (
    <div className="admin-create-user">
      <label className="admin-create-user__field">
        <span className="admin-create-user__field__label">
          Voornaam
        </span>
        <Input 
          className="admin-create-user__field__input"
          value={firstName}
          onInputChange={({ target: { value } }) => setFirstName(value)}
          placeholder="voornaam"
        />
      </label>
      {errors.firstName && (
        <p className="admin-create-user__error">{errors.firstName}</p>
      )}
      <label className="admin-create-user__field">
        <span className="admin-create-user__field__label">
          Achternaam
        </span>
        <Input 
          className="admin-create-user__field__input"
          value={lastName}
          onInputChange={({ target: { value } }) => setLastName(value)}
          placeholder="achternaam"
        />
      </label>
      {errors.lastName && (
        <p className="admin-create-user__error">{errors.lastName}</p>
      )}
      <label className="admin-create-user__field">
        <span className="admin-create-user__field__label">
          Zakelijk e-mailadres
        </span>
        <Input 
          className="admin-create-user__field__input"
          value={email}
          onInputChange={({ target: { value } }) => setEmail(value)}
          placeholder="e-mailadres"
        />
      </label>
      {errors.email && (
        <p className="admin-create-user__error">{errors.email}</p>
      )}
      <div className="admin-create-user__actions">
        <Button layout="outlined" onClick={onClose} className="admin-create-user__actions__action">
          Annuleer
        </Button>
        <Button onClick={onSubmit} isLoading={createUserMutation.isPending} className="admin-create-user__actions__action">
          Voeg toe
        </Button>
      </div>
    </div>
  );
}

export default AdminCreateUser;